export const getters = {
    getProjectTypes: (state) => state.projectTypesOptions,
    getProfileData: (state) => state.profileData,
    getRoleSkills: (state) =>{
      return  state.roleSkills
    },
    getAssessments: (state) => state.assessments,
    getAssessmentInvitation: (state) => state.assessmentInvitation,
  };
  